var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3328",
    "data-name": "Rectangle 3328",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(899 320)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_189",
    "data-name": "Mask Group 189",
    transform: "translate(-899 -320)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checkmark-round",
    d: "M17.083,3.975a1.333,1.333,0,0,0-1.936.326L8.709,13.72,5.163,9.88a1.326,1.326,0,0,0-1.957-.065,1.533,1.533,0,0,0-.061,2.079s4.309,4.781,4.928,5.261a1.333,1.333,0,0,0,1.936-.326l7.382-10.8a1.532,1.532,0,0,0-.308-2.058Z",
    transform: "translate(900.789 321.435)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.122dce2c16caf3cc2b8607fab9e61638.svg";
export { ForwardRef as ReactComponent };